export default [
    {
        path: '/drive',
        meta: { title: 'MyMadrivo | Drive' },
        children: [
            {
                path: '/internal/drive/callcenter',
                name: 'driveCallcenters',
                component: () => import('@/views/pages/Drive/CallCenters.vue'),
                meta: { isInternal: true, title: 'MyMadrivo | Drive | Callcenters', requiresAbility: 'readCallCenters' }
            },
            {
                path: '/internal/drive/callcenter/advertisers',
                name: 'driveAdvertisers',
                component: () => import('@/views/pages/Drive/Advertisers.vue'),
                meta: { isInternal: true, title: 'MyMadrivo | Drive | Advertisers', requiresAbility: 'readCallCenters' }
            },
            {
                path: '/internal/drive/callcenter/sites',
                name: 'driveSites',
                component: () => import('@/views/pages/Drive/Sites.vue'),
                meta: { isInternal: true, title: 'MyMadrivo | Drive | Sites', requiresAbility: 'readCallCenters' }
            },
            {
                path: '/internal/drive/callcenter/leads',
                name: 'driveLeads',
                component: () => import('@/views/pages/Drive/Leads.vue'),
                meta: { isInternal: true, title: 'MyMadrivo | Drive | Leads', requiresAbility: 'readCallCenters' }
            }
        ]
    }
];
